import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';

export const copyText = (text, onCopied) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(onCopied);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  onCopied();
};

export const CopyButton = ({ text, onCopied }) => (
  <Button type="button" color="link" className="bulk-word-copy" onClick={() => copyText(text, onCopied)}>
    전체복사
  </Button>
);

export const BulkWordNotice = ({ color = 'warning', className = '', children }) => (
  <Alert color={color} className={`bulk-word-notice ${className}`}>
    <div className="alert__content">{children}</div>
  </Alert>
);

export const BulkWordCheckbox = ({ id, label, checked, disabled = false, className = '', onChange }) => (
  <label className={`checkbox-btn bulk-word-checkbox${disabled ? ' disabled' : ''}${className ? ` ${className}` : ''}`}
         htmlFor={id}>
    <input className="checkbox-btn__checkbox" type="checkbox" id={id} checked={checked}
           disabled={disabled} onChange={onChange}/>
    <span className="checkbox-btn__checkbox-custom">
      <svg className="mdi-icon" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
      </svg>
    </span>
    <span className="checkbox-btn__label">{label}</span>
  </label>
);

export const BulkWordSection = ({ title, count, text, onCopied, actions, children }) => (
  <section className="bulk-word-section">
    <div className="bulk-word-section__header">
      <h5>{title} <span>{count}건</span></h5>
      <div className="bulk-word-section__actions">
        {actions}
        {text && <CopyButton text={text} onCopied={onCopied}/>}
      </div>
    </div>
    {children}
  </section>
);

export const ExpandableWordList = ({ lines, limit = 20, className = '' }) => {
  const [expanded, setExpanded] = useState(false);

  if (!lines || lines.length === 0) return null;

  const visibleLines = expanded ? lines : lines.slice(0, limit);
  return (
    <div>
      <pre className={`bulk-word-list ${className}`}>{visibleLines.join('\n')}</pre>
      {lines.length > limit && (
        <Button type="button" color="link" className="bulk-word-more" onClick={() => setExpanded(!expanded)}>
          {expanded ? '접기' : `${lines.length - limit}개 더보기`}
        </Button>
      )}
    </div>
  );
};

export const FailureList = ({ failures }) => {
  if (!failures || failures.length === 0) return null;
  return (
    <BulkWordNotice color="warning" className="bulk-word-failures alert--bordered">
      <div>
        <div className="bulk-word-failures__header">
          <strong>처리하지 못한 단어</strong>
          <span>{failures.length}건</span>
        </div>
        <ExpandableWordList lines={failures.map(item => `${item.word} - ${item.resultMessage} (${item.resultCode})`)}/>
      </div>
    </BulkWordNotice>
  );
};
